import { getUrlQuery } from 'better-js-lib';
import request from '@utils/request';

// const { default: PassPort, AuthLoginType } = require('@sftc/passport');
let PassPort;
if (typeof window !== 'undefined') {
  PassPort = require('@sftc/passport');
}

// 种STOKEN的公用接口
export const getCommonInfo = params => request.get('/market-cms/common/setcookie', params);

export const getUserInfo = async () => {
  try {
    const sdk = PassPort.default({
      platform: 'crm',
      // host: 'https://passtc.sf-express.com',
      // 内网需要安装 ssl 证书，下载地址：https://fsdocs.sf-express.com/document/DQXFHVmlXaXpmVEx1SUFSb0Zq
      host: 'https://passtc.sf-express.com'
    });
    const authCode = getUrlQuery('authCode');
    console.log('authCode>>>>>>>>>>', authCode);
    // 1、用authCode请求passSDK，拿STOKEN
    const loginType = PassPort.AuthLoginType.JsonResponse;
    const res = await sdk.loginByAuthCode({ authCode, loginType });
    // 2、拿STOKEN请求公共接口,种STOKEN
    const stokenObject = res.find(item => item.key === 'STOKEN');
    await getCommonInfo({ STOKEN: stokenObject.value || '' });
  } catch (error) {
    console.log(error, '错误信息');
  }
};
